export const BATCH_STATUS_LABELS: Record<number, string> = {
  1: 'Draft',
  2: 'Processing',
  3: 'Completed',
  4: 'Failed',
  5: 'Preparing', // BatchStatus.Enumerating — SharePoint folder walk still running in the background
};

export function batchStatusLabel(status: number | string): string {
  if (typeof status === 'number') {
    return BATCH_STATUS_LABELS[status] ?? String(status);
  }
  return status === 'Enumerating' ? 'Preparing' : status;
}

export function batchStatusClass(status: string): string {
  switch (status) {
    case 'Completed':
    case 'Processed':
    case 'Passed':
      return 'badge-completed';
    case 'Processing':
    case 'Pending':
    case 'Uploaded':
    case 'Uploading':
      return 'badge-processing';
    case 'Failed':
      return 'badge-failed';
    case 'Draft':
    case 'Created':
      return 'badge-draft';
    case 'Preparing':
    case 'Enumerating':
      return 'badge-preparing';
    default:
      return 'badge-default';
  }
}

export function isDraft(status: string): boolean {
  return status === 'Draft' || status === 'Created';
}

/** True while the SharePoint folder walk is still running in the background
 * (BatchStatus.Enumerating) — no documents exist yet, so ingestion can't start
 * and this is distinct from `isDraft`. */
export function isPreparing(status: string): boolean {
  return status === 'Preparing' || status === 'Enumerating';
}

export function isProcessing(status: string): boolean {
  return status === 'Processing' || status === 'Pending' || status === 'Uploaded' || status === 'Uploading';
}

export function documentStatusLabel(status: string): string {
  switch (status) {
    case 'Passed':
      return 'Completed';
    case 'Pending':
    case 'Uploaded':
    case 'Uploading':
      return 'Processing';
    default:
      return status;
  }
}

export function isDocumentCompleted(status: string): boolean {
  return status === 'Passed' || status === 'Completed' || status === 'Processed';
}

/** SignalR / route / API Guids can differ in casing; group names and payload checks must match. */
export function idsEqual(a: unknown, b: unknown): boolean {
  if (a == null || b == null) return false;
  return String(a).toLowerCase() === String(b).toLowerCase();
}
